const ALL_LOCAL_STORAGE_KEYS = [
  '__is_auto_reset',
  'orderPlaced',
  'active-ez-ship-manager',
  'sidebar-nav-clicked',
  'isLegitimateNavigation',
  'enrollment',
  'petProfile',
  'petRecommendations',
  'recentSearches',
  'petProfilesRecommendedItems',
  'petProfile',
];

export const clearAllLocalStorage = () => {
  ALL_LOCAL_STORAGE_KEYS.forEach(key => {
    localStorage.removeItem(key);
  });
};
